import { helpers } from "vuelidate/lib/validators";

const contains = (param: string) => (value: string) => !helpers.req(value) || value.indexOf(param) <= 0;

export default contains;
